import React, { useEffect, useState } from 'react';
import Button from '@material-ui/core/Button';
import { Link } from 'react-router-dom';
import { base_url } from '../../Api/Api';
import Skeleton from '@material-ui/lab/Skeleton';
import SkltnTicketDetails from './skltn/sklnTiketDetails';

const TicketDetail = (props) => {

    const [state, setState] = useState({
        data: [],
        nameTiket: '',
        imageTiket: '',
    })

    useEffect(() => {

        window.scrollTo(0, 0)

        base_url.get(`ticket/${props.match.params.id}`)
            .then(response => {
                let nameTiket = JSON.parse(localStorage.getItem('nameTiket'))
                let imageTiket = JSON.parse(localStorage.getItem('imageTiket'))
                let tempData = response.data.ticket.comments
                let firtTiket = {
                    'comment': response.data.ticket.message,
                    'jdate': response.data.ticket.jdate,
                    'image': response.data.ticket.image,
                    'is_reply': false
                }
                tempData.push(firtTiket)
                setState({
                    ...state,
                    data: response.data.ticket,
                    comments: tempData,
                    nameTiket: nameTiket,
                    imageTiket: imageTiket
                })
            })
            .catch(error => {
                if (error.response != undefined) {
                    if (error.response.status == 401) {
                        props.history.push(`/Entrance`)
                        localStorage.clear()
                        window.location.reload()
                    }
                }
            })


    }, [])

    return (
        <div className="innerTicket">
            <div className="contain">
                <div className="inner-Ticket">
                    <div className="ticketTitle">
                        <span>مشخصات تیکت</span>
                        <span>پیام ها</span>
                        <div className="backward">
                            <Button
                                variant="contained"
                                onClick={() => props.history.goBack()} >بازگشت <i className="icon-arrow-down-sign-to-navigate-fill"></i></Button>
                        </div>
                    </div>
                    <div className="ticketBody">
                        <div className="ticketInfo">
                            {state.data.length == 0 ?
                                <span className="info skltn">
                                    <Skeleton animation="wave" width={100} height={24} />
                                    <b><Skeleton animation="wave" width={36} height={24} /></b>
                                </span>
                                :
                                <span className="info">شماره تیکت :
                                    <b>{state.data.id}</b>
                                </span>
                            }
                            {state.data.length == 0 ?
                                <span className="info skltn">
                                    <Skeleton animation="wave" width={100} height={24} />
                                    <b><Skeleton animation="wave" width={140} height={24} /></b>
                                </span>
                                :
                                <span className="info">عنوان تیکت :
                                    <b>{state.data.title}</b>
                                </span>
                            }
                            {state.data.length == 0 ?
                                <span className="info skltn">
                                    <Skeleton animation="wave" width={100} height={24} />
                                    <b><Skeleton animation="wave" width={140} height={24} /></b>
                                </span>
                                :
                                <span className="info">تاریخ ایجاد :
                                    <b>{state.data.jdate}</b>
                                </span>
                            }
                            {state.data.length == 0 ?
                                <span className="info skltn">
                                    <Skeleton animation="wave" width={100} height={24} />
                                    <b><Skeleton animation="wave" width={140} height={24} /></b>
                                </span>
                                :
                                state.data.comments.length == 0 ? null :
                                    <span className="info">تاریخ آخرین جواب :
                                    <b>{state.data.comments[0].jdate}</b>
                                    </span>
                            }
                            <div className="btns">
                                {state.data.length == 0 ?
                                    <Skeleton animation="wave" width={100 + '%'} height={43} />
                                    :
                                    state.data.status == 'close' ?
                                        <Button
                                            variant="contained"
                                            className="disabled" >ارسال پاسخ</Button>
                                        :
                                        <Link to={`/Tickets/ReplayedTicket/${state.data.length == 0 ? '' : state.data.id}`}>
                                            <Button
                                                variant="contained">ارسال پاسخ</Button>
                                        </Link>
                                }
                            </div>
                        </div>
                        <div className="messages">
                            {state.data.length == 0 ?
                                <SkltnTicketDetails />
                                : state.comments.length == 0 ? null :
                                    state.comments.slice(0, 300).map(info =>
                                        info.is_reply ?
                                            <div className="messageItem admin">
                                                <div className="username">
                                                    <div className="user">
                                                        <img src="/192.png" />
                                                        <span >مدیر</span>
                                                    </div>
                                                    <span className="date">{info.jdate}</span>
                                                </div>
                                                <p className="desc">{info.comment}</p>
                                                {info.image == null ? null :
                                                    <img className="infopic" src={info.image} />
                                                }
                                            </div>
                                            :
                                            <div className="messageItem">
                                                <div className="username">
                                                    <div className="user">
                                                        {state.imageTiket == null ? null :
                                                            <img src={state.imageTiket} />
                                                        }
                                                        {state.nameTiket == null ? null :
                                                            <span>{state.nameTiket}</span>
                                                        }
                                                    </div>
                                                    <span className="date">{info.jdate}</span>
                                                </div>
                                                <p className="desc">{info.comment}</p>
                                                {info.image == null ? null :
                                                    <img className="infopic" src={info.image} />
                                                }
                                            </div>
                                    )
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div >
    )
}

export default TicketDetail;